import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { useLocation, useHistory } from "react-router-dom";
import HeaderMenu from "./HeaderMenu/Header__Menu";

//MUI imports
import Menu from "components/Menu/Menu";
import MenuIcon from "assets/icons/menuIcon.png";
import PageButton from "../PageButton/PageButton";

//assets imports
import dhIcon from "assets/icons/dhIcon.png";


// userContext import
import { CurrentUserContext } from "context/UserContext";

const Header = () => {
  const location = useLocation();
  const [menuActive, setMenuActive] = useState(false);

  const [userContextData, setUserContextData] = useContext(CurrentUserContext);
  const loginStatus = userContextData.isLoggedIn;
  const userType = userContextData.admin;
  const history = useHistory();
  const handleSessionClose = () => {
    setUserContextData({
      isLoggedIn: false,
    });
    history.push("/home");
  };

  return (
    <>
      <div className="header">
        <Link className="dhIcon" to="/home">
          {/*<img src={dhIcon} alt="dhIcon" />*/}
          <img className={'logo'} src='/logo.webp' alt="dhIcon" />
        </Link>
        <Link className="dhIconMobile" to="/home">
          <img src='/logo.webp' alt="dhIconMobile" />
        </Link>
        <div className="header__menu" onClick={setMenuActive}>
          <img src={MenuIcon} alt="Menu icon" />
        </div>
        <div className="header__controls__container">
          {(() => {
            if (!loginStatus)
              return (
                <div className="button__container">
                  {location.pathname !== "/signup" && (
                    <Link to="/signup">
                      <PageButton label="Crear cuenta" />
                    </Link>
                  )}
                  {location.pathname !== "/login" && (
                    <Link to="/login">
                      <PageButton label="Iniciar Sesión" />
                    </Link>
                  )}
                </div>
              );
            return (
              <>
                <div className="header__avatar__container">
                  <div className="header__adminTitle">
                    <HeaderMenu
                      userType={userType}
                      handleLogOut={handleSessionClose}
                    />
                  </div>
                  <Avatar sx={{ width: "6vh", height: "6vh" }}>
                    {userContextData.name.toUpperCase().slice(0, 1)}
                    {userContextData.surname.toUpperCase().slice(0, 1)}
                  </Avatar>
                  <div className="header__avatar__container__text">
                    <p style={{ color: "black" }}>Hola,</p>
                    <p className="">{`${userContextData.name} ${userContextData.surname}`}</p>
                  </div>{" "}
                </div>
              </>
            );
          })()}
        </div>
      </div>
      <Menu statusHandler={[menuActive, setMenuActive]} />
    </>
  );
};
export default Header;
